<template>
    <div class="transfers-row" ref="transfersRow">
      <div v-for="(team, index) in uniqueTeamList" :key="`team-${team.id}-${index}`" class="team-and-separator">
        <!-- Container for the logo with 1:1 aspect ratio -->
        <div class="logo-container">
          <img :src="team.logo_url" :alt="team.name" class="team-logo" :data-club-name="team.name" :title="team.name">
        </div>
        <span v-if="index < uniqueTeamList.length - 1" class="separator">></span>
      </div>
    </div>
  </template>

  
<script>
export default {
    props: {
        transfers: {
            type: Array,
            required: true
        }
    },
    mounted() {
        this.adjustLayout();
    },
    watch: {
        uniqueTeamList() {
            this.$nextTick(() => {
                this.adjustLayout();
            });
        }
    },

    methods: {
        adjustLayout() {
            const transfersRow = this.$refs.transfersRow;

            if (transfersRow) {
                // Check if the content is wider than the viewport
                if (transfersRow.scrollWidth > transfersRow.clientWidth) {
                    // Content is wider than the viewport
                    transfersRow.style.justifyContent = 'flex-start';
                    transfersRow.scrollLeft = transfersRow.scrollWidth; // Scroll to the end
                } else {
                    // Content fits within the viewport
                    transfersRow.style.justifyContent = 'center';
                }
            }
        }
    },

    computed: {
        sortedTransfers() {
            return [...this.transfers].sort((a, b) => {
                const dateA = new Date(a.transfer_date);
                const dateB = new Date(b.transfer_date);
                return dateA - dateB;
            });
        },
        uniqueTeamList() {
            const currentDate = new Date();
            const teamList = [];
            const threeMonths = 90 * 24 * 60 * 60 * 1000; // 3 months in milliseconds

            // Filter out future transfers
            let validTransfers = this.sortedTransfers.filter(transfer => {
                const transferDate = new Date(transfer.transfer_date);
                return transferDate <= currentDate;
            });

            const filteredTransfers = [];

            for (let index = 0; index < validTransfers.length; index++) {
                const transfer = { ...validTransfers[index] }; // make a shallow copy

                if (index < validTransfers.length - 1) {
                    const nextTransfer = validTransfers[index + 1];
                    const currentTransferDate = new Date(transfer.transfer_date);
                    const nextTransferDate = new Date(nextTransfer.transfer_date);

                    if (
                        transfer.to_team.id === nextTransfer.from_team.id &&
                        Math.abs(currentTransferDate - nextTransferDate) <= threeMonths
                    ) {
                        nextTransfer.from_team = transfer.from_team; // skip the middle team
                        continue; // skip this transfer but don't skip the next one
                    }
                }

                filteredTransfers.push(transfer); // include this transfer
            }

            // Make a single list of teams
            filteredTransfers.forEach((transfer) => {
                // Add 'from_team' if it's not the same as the last one added
                if (teamList.length === 0 || teamList[teamList.length - 1].id !== transfer.from_team.id) {
                    teamList.push(transfer.from_team);
                }
                // Add 'to_team' if it's not the same as the last one added
                if (teamList[teamList.length - 1].id !== transfer.to_team.id) {
                    teamList.push(transfer.to_team);
                }
            });

            // Remove instances of A - B - A - B
            // Remove instances of A - B - A - B
            let i = 0;  // Initialize i outside the for loop
            while (i < teamList.length - 3) {  // Changed from a for loop to a while loop
                if (
                    teamList[i] && teamList[i + 2] && teamList[i + 1] && teamList[i + 3] &&  // Check for undefined
                    teamList[i].id === teamList[i + 2].id &&
                    teamList[i + 1].id === teamList[i + 3].id
                ) {
                    teamList.splice(i + 2, 2);  // Remove the last pair
                    i = Math.max(0, i - 2);  // Re-check from two positions back but not less than 0
                } else {
                    i++;  // Move to the next position
                }
            }

            return teamList;
        },
    },
}
</script>
  
<style scoped>
.transfers-row {
    display: flex;
    flex-wrap: no-wrap;
    align-items: center;
    justify-content: center;
    user-select: none;
    /* overflow-x: auto; Add this line to enable horizontal scrolling */
    /* margin-left: 2em;
    margin-right: 2em; */
}

.team-and-separator {
    flex-shrink: 0; /* Prevents items from shrinking */
    display: inline-flex;
    align-items: center;
    margin-bottom: 1em;
}

.logo-container {
    width: 120px; /* Width of the container */
    height: 120px; /* Height of the container, same as width for 1:1 aspect ratio */
    max-height: 6em;
    max-width: 6em;
    display: flex;
    justify-content: center; /* Center the image horizontally */
    align-items: center; /* Center the image vertically */
    overflow: hidden; /* Hide overflow if the image is bigger than the container */
}

.team-logo {
    max-height: 100%; /* Limit the height to the container size */
    max-width: 100%; /* Limit the width to the container size */
    object-fit: contain; /* Ensure the aspect ratio is maintained without stretching */
}

.separator {
    font-size: 8pt;
    white-space: nowrap;
    margin-left: 5px;
    margin-right: 5px;
    font-weight: bold;
}
</style>
  